import React from "react"
import News from "../../blocks/news"
import { graphql } from "gatsby"

export const pageQuery = graphql`
query {
  news: newsYaml(slug: { eq: "krapukhin_signs_with_catenaccio" }) {
    ...NewsInfo
  }
}`

export default class NewsText extends News {
  renderNews() {
    return (
      <div className="row">
        <div className="col-xl-12">
          <p>Станислав Крапухин, нападающий ФК Рига, официально стал клиентом футбольного агенства Catenaccio Sports Agency.</p>
        </div>
      </div>
    )
  }
}